import { Schema } from "rsuite";
import { template } from "lodash";

import i18n from "utils/i18n";
import constants from "utils/constants";

import { SettingsFormValue } from "./settings-helpers";

const { NumberType } = Schema.Types;

export type GroupItem = {
    readonly title?: string;
    readonly description?: string;
};

export type SettingRule = ReturnType<
    typeof NumberType<SettingsFormValue, string>
>;

export const descriptions: Map<string, GroupItem> = new Map<string, GroupItem>([
    [
        "PaymentInformationImportMaxAgeInMonths",
        {
            title: i18n.t(
                "tenantConfig.axImportControl.settings.paymentInformation.title"
            ),
            description: i18n.t(
                "tenantConfig.axImportControl.settings.paymentInformation.description"
            ),
        },
    ],
]);

export const rules: Map<string, SettingRule> = new Map<string, SettingRule>([
    [
        "PaymentInformationImportMaxAgeInMonths",
        NumberType<SettingsFormValue, string>(
            i18n.t("generalValidationMessages.notInteger")
        )
            .isRequired(i18n.t("generalValidationMessages.isRequired"))
            .isInteger(i18n.t("generalValidationMessages.notInteger"))
            .range(
                constants.ranges.minRangeValue1,
                constants.ranges.maxRangeValue99,
                template(i18n.t("generalValidationMessages.numberRange"))({
                    min: constants.ranges.minRangeValue1,
                    max: constants.ranges.maxRangeValue99,
                })
            ),
    ],
]);
